import "./notfound.scss";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <main className="notfound__main">
      <h3>Error 404</h3>
      <h4>Hmm, we can't find that page</h4>
      <h2>
        It seems the page you are looking for does not exist.
        <br></br>Head back to the homepage.
      </h2>

      <button onClick={() => navigate("/")}>Back To Homepage</button>
    </main>
  );
}
